import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as employeeApi from '../../lib/api/employee';

const [VIEW_EMPLOYEE, VIEW_EMPLOYEE_SUCCESS, VIEW_EMPLOYEE_FAILURE] =
  createRequestActionTypes('employee/VIEW_EMPLOYEE');
export const viewEmployee = createAction(VIEW_EMPLOYEE, (id) => id);
const viewEmployeeSaga = createRequestSaga(VIEW_EMPLOYEE, employeeApi.getEmployee);

const UNLOAD_EMPLOYEE = 'employee/UNLOAD_EMPLOYEE';
export const unloadEmployee = createAction(UNLOAD_EMPLOYEE);

const SET_EMPLOYEE = 'employee/SET_EMPLOYEE';
export const setEmployee = createAction(SET_EMPLOYEE, (employee) => employee);

export function* employeeSaga() {
  yield takeLatest(VIEW_EMPLOYEE, viewEmployeeSaga);
}

const initialState = {
  employee: null,
  error: null,
};

const employee = handleActions(
  {
    [VIEW_EMPLOYEE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      employee: data,
    }),
    [VIEW_EMPLOYEE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [UNLOAD_EMPLOYEE]: () => initialState,
    [SET_EMPLOYEE]: (state, { payload: employee }) => ({
      ...state,
      employee: employee,
    }),
  },
  initialState,
);

export default employee;
